import { Box, SectionHelper, Text } from '@wix/design-system';
import React from 'react';
import { useDowngradeModal } from '../../../hooks/useDowngradeModal';
import { SwitchProductModule } from '../../../switch-product.module';
export const DisabledFeaturesMessage = () => {
  var _downgradeDetails$cur, _downgradeDetails$des;
  const {
    t
  } = SwitchProductModule.internals.useTranslations();
  const {
    downgradeDetails
  } = useDowngradeModal();
  const explanationKey = downgradeDetails != null && downgradeDetails.verticalFeatureRemoved ? 'Advanced.Plans_change.plan_modal.premium_features_disabled_payments' : 'Advanced.Plans_change.plan_modal.premium_features_disabled';
  return /*#__PURE__*/React.createElement(Box, {
    marginTop: "26px"
  }, /*#__PURE__*/React.createElement(SectionHelper, {
    skin: "danger",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, t(explanationKey, {
    originPlanName: downgradeDetails == null || (_downgradeDetails$cur = downgradeDetails.currentPlanDetails) == null ? void 0 : _downgradeDetails$cur.localizedProductName,
    planName: downgradeDetails == null || (_downgradeDetails$des = downgradeDetails.destinationProductDetails) == null ? void 0 : _downgradeDetails$des.localizedProductName
  }))));
};
//# sourceMappingURL=DisabledFeaturesMessage.js.map